import App from "next/app";
import Head from "next/head";
import React from "react";
import { createGlobalStyle } from "styled-components";
import ThemeProvider from "components/ThemeProvider";

import "iconfont/iconfont.css";

const GlobalStyle = createGlobalStyle`
	html, body {
		padding: 0;
		margin: 0;
		font-family: Avenir-Roman,Avenir,sans-serif;
		overflow-x: hidden;
	}
	ul, li, p, section, div, h1, h2, h3, h4, h5, h6, dd, dt, header, footer, nav, main {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}
	main{
		overflow-x: hidden;
	}
	ul {
		list-style: none
	}
	a {
		text-decoration: none;
	}

	:root {
		--fontBold: "Avenir-Heavy";
		--fontRegular: "Avenir";
		--fontMedium: "Avenir-Roman";
	}
`;

export default class MyApp extends App {
  render() {
    const { Component, pageProps } = this.props;
    const { title, ...modProps } = pageProps;
    const seoDesc = pageProps?.page?.seoDesc;
    return (
      <React.Fragment>
        <GlobalStyle />
        <Head>
          <title>{title}</title>
          <meta
            name="viewport"
            content="width=device-width,, viewport-fit=cover, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
          />
          <meta name="full-screen" content="yes" />
          <meta name="x5-fullscreen" content="true" />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta name="mobile-web-app-capable" content="yes" />
          <meta
            name="apple-mobile-web-app-status-bar-style"
            content="#3E82F7"
          />
          <meta name="apple-mobile-web-app-title" content="OUKU" />
          <meta name="screen-orientation" content="portrait" />
          <meta name="x5-orientation" content="portrait" />
          <meta name="browsermode" content="application" />
          <meta name="x5-page-mode" content="app" />
          {seoDesc && <meta name="description" content={seoDesc}></meta>}
        </Head>
        <ThemeProvider>
          <Component {...modProps} />
        </ThemeProvider>
      </React.Fragment>
    );
  }
}
